import OadpRadioGroup from './oadp-radio-group';
export default OadpRadioGroup;
